<template>
  <div>
    <div class="box">
      <div class="flex mb-40">
        <img :src="info.xct ? info.xct : require('@/assets/images/defaultImg.jpg')" alt="" width="420" height="234">
        <div class="detail">
          <div class="title">{{ info.name }}</div>
          <div class="flex-btw">
            <div class="flex">
              <div class="label">培训时间：</div>
              <div>{{ info.startTime.replaceAll('-', '.') }}—{{ info.endTime.replaceAll('-', '.') }}</div>
            </div>
            <div class="flex">
              <div class="label">培训人数：</div>
              <div>{{info.bmCount}}</div>
            </div>
            <div class="flex">
              <div class="label">总学时：</div>
              <div style="color: #E4381D;">{{ allHour }}</div>
            </div>
          </div>
          <div class="flex mtb-15">
            <div class="label">牵头承办单位：</div>
            <div>{{ info.receiveOrgName }}</div>
          </div>
          <div class="flex">
            <div class="label">联合承办单位：</div>
            <div>{{ info.unionOrgNames }}</div>
          </div>
          <div class="flex-base mtb-14">
            <div class="label">培训学时：</div>
            <div class="detail-tips">
              <div class="detail-tip" v-for="item in courses" v-if="item.allHour > 0">{{ item.label }}:{{ item.allHour }}</div>
              <!-- <div class="detail-tip">网络学习:13</div>
              <div class="detail-tip">专题研讨:8</div>
              <div class="detail-tip">实践锻炼:12</div>
              <div class="detail-tip">个人自学:10</div> -->
            </div>
          </div>
          <div class="flex">
            <div class="label">培训通知：</div>
            <div style="text-decoration: underline; color: #E4381D; cursor: pointer;" @click="$router.push('/notice/detail?id=' + $route.query.id)">{{ info.name }}</div>
          </div>
        </div>
      </div>
      <div class="mb-30" v-if="courses[0].list.length>0">
        <div class="tip-box">
          <div class="tips">集中授课</div>
        </div>
        <div class="flex mt-24 mb-20">
          <div class="flex">
            <div class="label">时间：</div>
            {{ courses[0].list[0].startTime }}—{{ courses[0].list[0].endTime }}
          </div>
          <div class="flex" style="margin-left: 60px;">
            <div class="label">地点：</div>
            {{courses[0].list[0].address}}
          </div>
        </div>
        <div class="table">
          <div class="head">
            <div>第几讲</div>
            <div>学时</div>
            <div class="flex-2">课程名称</div>
            <div>授课老师</div>
          </div>
          <div class="">
            <div class="table-row"  v-for="(item,index) in courses[0].list">
              <div>{{ index + 1 }}</div>
              <div>{{item.hours}}</div>
              <div class="flex-2">{{item.courseName}}</div>
              <div>{{item.teacherName}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-30" v-if="courses[1].list.length>0">
        <div class="tip-box mb-24 wlxx">
          <div class="tips">网络学习</div>
          <div class="wlxx-jd" v-if="isBm">
            学习进度：{{info.wxProgress||0}}%
          </div>
        </div>
        <div class="table">
          <div class="head">
            <div>序号</div>
            <div class="flex-2">课程名称</div>
            <div>主讲人</div>
            <div>学时</div>
            <div v-if="isBm">进度</div>
            <div v-if="isBm">操作</div>
          </div>
          <div class="">
            <div class="table-row" v-for="(item, index) in courses[1].list">
              <div>{{ index + 1 }}</div>
              <div class="flex-2">{{item.courseName}}</div>
              <div>{{item.teacherName}}</div>
              <div>{{item.hours}}</div>
              <div v-if="isBm">{{item.progress*100}}%</div>
              <div v-if="isBm">
                <div class="table-btn" @click="handleCourse(item)">学习</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-30" v-for="(itemC,indexC) in courses" :key="indexC" v-if="indexC>1 && itemC.list.length>0">
        <div class="tip-box mb-24">
          <div class="tips">{{itemC.label}}</div>
        </div>
        <div class="table">
          <div class="head">
            <div>序号</div>
            <div>学时</div>
            <div class="flex-2">{{ itemC.colLabel }}</div>
            <div>时间</div>
            <div class="flex-2">{{ itemC.colLabel2 }}</div>
          </div>
          <div class="">
            <div class="table-row"  v-for="(c,c_index) in itemC.list">
              <div>{{ c_index + 1 }}</div>
              <div>{{c.hours}}</div>
              <div class="flex-2">{{c.courseName}}</div>
              <div>{{c.startTime.replaceAll('-', '.')}}-{{c.endTime.replaceAll('-', '.')}}</div>
              <div class="flex-2">{{c.address}}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="info.paperList && info.paperList.length > 0">
        <div class="tip-box mb-24">
          <div class="tips">我的考试</div>
        </div>
        <div class="table">
          <div class="head">
            <div class="flex-3">考试</div>
            <div class="flex-2">考试时间</div>
            <div>卷面总分</div>
            <div>考试时长（分钟）</div>
            <div v-if="isBm">操作</div>
          </div>
          <div class="">
            <div class="table-row" v-for="item in info.paperList">
              <div class="flex-3">{{ item.name }}</div>
              <div class="flex-2">{{ item.startTime.replaceAll('-', '.') }}-{{ item.endTime.replaceAll('-', '.') }}</div>
              <div>{{ item.totalScore }}</div>
              <div>{{ item.duration }}</div>
              <div v-if="isBm">
                <div class="table-btn" v-if="!item.examDataId"  @click="start(item)">开始考试</div>
                <div class="table-btn" v-if="item.examDataStatus == 'WJJ' && item.examDataId"  @click="start(item)">继续考试</div>
                <div @click="view(item)" class="score" v-if="item.examDataStatus && item.examDataStatus != 'WJJ' ">
                  <div v-if="item.examDataStatus =='YJJDPG'">批阅中</div>
                  <div v-else class="fsize-20 flex" style="cursor: pointer; color: #E1311A; text-decoration: underline;">{{ item.score ? item.score : 0  }}<div class="fszie-14">分</div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getXmDetail } from '@/api/index'
export default {
  data() {
    return {
      info: {},
      courses:[
        {label:'集中授课',value:'JZPX',list:[], allHour: 0},
        {label:'网络学习',value:'WLXX',list:[], allHour: 0},
        {label:'集体学习',value:'JTXX',list:[], allHour: 0, colLabel: '学习内容', colLabel2: '学习地点'},
        {label:'专题研讨',value:'ZTYT',list:[], allHour: 0, colLabel: '研讨内容', colLabel2: '研讨地点'},
        {label:'实践锻炼',value:'SJDL',list:[], allHour: 0, colLabel: '锻炼内容', colLabel2: '锻炼地点'},
        {label:'个人自学',value:'GRZX',list:[], allHour: 0, colLabel: '自学内容', colLabel2: '自学渠道或平台'},
        {label:'其他形式',value:'QTXS',list:[], allHour: 0, colLabel: '学习内容', colLabel2: '学习地点或渠道'}
      ],
      allHour: 0,
      isBm:false
    }
  },
  created() {
    getXmDetail({ id: this.$route.query.id }).then(res => {
      this.info = res
      this.isBm=res.bmInfo&&(res.bmInfo.length>0)
      res.xmCourseSetting.chooseCourseList.map(item=>{
        this.courses.map(v=>{
          if(item.studyMode == v.value){
            v.list.push(item)
            v.allHour += +item.hours
            this.allHour += +item.hours
          }
        })
      })
    })
  },
  methods: {
    handleCourse(e) {
      const now=new Date().getTime(),
      sTime=new Date(this.info.startTime).getTime(),  
      eTime=new Date(this.info.endTime).getTime();
      
      if(now>eTime||sTime>now){
          this.$message({
            message: '不在学习时间范围内',
            type: 'error'
          })
          return 
      }
      this.$router.push({ path: '/myTrain/course?id=' + e.resourceId + '&xmId=' + this.$route.query.id })
    },
    start(e) {
      const now=new Date().getTime(),
      sTime=new Date(e.startTime).getTime(),  
      eTime=new Date(e.endTime).getTime();
      
      if(now>eTime||sTime>now){
          this.$message({
            message: '不在考试时间范围内',
            type: 'error'
          })
          return 
      }
      this.$router.push({
          path: '/myTest/myPaperList/myPaper',
          query: {
              paperId: e.id
          }
      })
    },
    view(e) {
      console.log(123123);
      this.$router.push({
        path: '/myTest/myPaperList/myPaperView',
        query: {
          paperId: e.id,
          dataId: e.examDataId,
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  background-color: #fff;
  padding: 24px 24px 40px 24px;
}

.title {
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  margin-bottom: 20px;
}

.label {
  color: #767676;
  flex-shrink: 0;
}

.detail {
  flex: 1;
  margin-left: 24px;
  padding-top: 10px;
  padding-right: 60px;

  .detail-tips {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    .detail-tip {
      font-size: 14px;
      line-height: 30px;
      padding: 0 12px;
      color: #F59A23;
      background: linear-gradient( 147deg, rgba(245,154,35,0.1) 0%, rgba(255,144,26,0.1) 98%);
      border-radius: 4px 4px 4px 4px;
      // margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.tip-box {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 1px solid #E4381D;

  .tips {
    position: relative;
    padding: 0 18px 0 10px;
    background: linear-gradient( 270deg, #E4381D 0%, #D81D10 100%);
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 28px;

    &::before {
      content: '';
      position: absolute;
      z-index: 22;
      width: 0;
      height: 0;
      right: 0;
      border-right: 12px solid #fff; /* 高度 */
      border-bottom: 28px solid transparent; /* 透明的上边框 */
    }

    &::after {
      content: '';
      position: absolute;
      z-index: 22;
      right: -10px;
      width: 10px;
      height: 28px;
      background: linear-gradient( 147deg, #F59A23 0%, #FF901A 98%);
      transform: skew(26deg);
    }
  }
}
.wlxx{
  justify-content: start;
  .wlxx-jd{
    margin-left: 40px;
    color: #F59A23;
  }
}
.table {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  border-right: 1px solid #E3E3E3;
  border-bottom: 1px solid #E3E3E3;

  .head {
    display: flex;
    background: #EEEEEE;
    border-top: 1px solid #E3E3E3;
    border-left: 1px solid #E3E3E3;

    div {
      flex: 1;
      border-right: 1px solid #E3E3E3;
      padding: 10px 0;

      &:last-child {
        border-right: none;
      }
    }

    .flex-2 {
      flex: 2;
    }

    .flex-3 {
      flex: 3;
    }
  }

  .table-row {
    display: flex;

    >div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      border-top: 1px solid #E3E3E3;
      border-left: 1px solid #E3E3E3;
    }

    .flex-2 {
      flex: 2;
    }

    .flex-3 {
      flex: 3;
    }

    .table-btn {
      width: 74px;
      line-height: 24px;
      background: linear-gradient( 147deg, #F59A23 0%, #FF901A 98%);
      border-radius: 3px 3px 3px 3px;
      font-size: 14px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>